import { Button } from '../components/ui/Button'

export function LoginScreen() {
  return (
    <div
      className="flex flex-col items-center justify-center"
      style={{ minHeight: '100svh', background: 'var(--color-surface-base)', padding: 'var(--spacing-6)' }}
    >
      <img
        src={`${import.meta.env.BASE_URL}zota-logo.svg`}
        alt="Zota"
        style={{ height: '28px', width: 'auto', marginBottom: 'var(--spacing-8)' }}
      />
      <h1
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 'var(--text-title-md)',
          fontWeight: 'var(--weight-semibold)',
          color: 'var(--color-text-primary)',
          margin: '0 0 var(--spacing-2) 0',
        }}
      >
        Admin console
      </h1>
      <p
        style={{
          fontFamily: 'var(--font-body)',
          fontSize: 'var(--text-body-sm)',
          color: 'var(--color-text-secondary)',
          margin: '0 0 var(--spacing-8) 0',
          textAlign: 'center',
        }}
      >
        Sign in with your work Google account.
      </p>
      <Button variant="primary" onClick={() => window.location.assign('/api/v1/admin/auth/google')}>
        Sign in with Google
      </Button>
    </div>
  )
}
